import { api } from "@lumberset/api-client";
import { HelpAssistant } from "@lumberset/support-ui";
import { Container, SectionHeader } from "@lumberset/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/help/ask")({ component: AskPage });

function AskPage() {
  const navigate = useNavigate();
  return (
    <Container className="divide-y p-0">
      {/* The assistant says itself where its answers come from, and how to reach a person. */}
      <SectionHeader level="h1" title="Ask the assistant" />
      <div className="px-6 py-5">
        <div className="mx-auto w-full max-w-3xl">
          <HelpAssistant
            api={api}
            onOpenArticle={(slug) => navigate({ to: "/help/$slug", params: { slug } })}
          />
        </div>
      </div>
    </Container>
  );
}
